import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { OptimalSelectedProductInterface, SelectedProductInterface } from '../data';
import { OrderProvider } from '../providers/order.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetOptimalSelectedProductUseCaseParams {
    product: SelectedProductInterface;
}

@Injectable()
export class GetOptimalSelectedProductUseCase
    implements UseCaseWithParam<GetOptimalSelectedProductUseCaseParams, Observable<Transaction<OptimalSelectedProductInterface>>>
{
    constructor(private contractProvider: ContractProvider, private orderProvider: OrderProvider) {}

    bind(params: GetOptimalSelectedProductUseCaseParams): Observable<Transaction<OptimalSelectedProductInterface>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) =>
                        this.orderProvider.findOptimal(contract.encryptedCode, params.product).pipe(
                            map((transactionOptimal) =>
                                transactionOptimal.map(
                                    (product) => Transaction.success(cloneDeep(product)),
                                    (throwable) => Transaction.error(throwable.message)
                                )
                            )
                        ),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
